// HOME에서 사용하는 JS Events
document.addEventListener('DOMContentLoaded', () => {

  // Hero 영역 - 모바일에서 슬라이드
  const mainHero = document.querySelector('.custom-col-hero');
  const mainHeroContainer = document.querySelector('.custom-col-hero ul');
  const mainHeroSliders = document.querySelectorAll('.custom-col-hero ul li');
  
  // Editorial Stories 영역 - 모바일에서 슬라이드
  // const mainBlogStories = document.querySelector('.editorial.stories');
  // const mainBlogStoriesContainer = document.querySelector('.editorial.stories ul');
  // const mainBlogStoriesSliders = document.querySelectorAll('.editorial.stories ul li');
  
  // Editorial People 영역 - 모바일에서 슬라이드
  // const mainBlogTrend = document.querySelector('.editorial.trend');
  // const mainBlogTrendContainer = document.querySelector('.editorial.trend ul');
  // const mainBlogTrendSliders = document.querySelectorAll('.editorial.trend ul li');
  
  // Editorial People 영역 - 모바일에서 슬라이드
  // const mainBlogPeople = document.querySelector('.editorial.people');
  // const mainBlogPeopleContainer = document.querySelector('.editorial.people ul');
  // const mainBlogPeopleSliders = document.querySelectorAll('.editorial.people ul li');
  
  // Keyword 영역 - 모바일에서 슬라이드
  // const mainKeyword = document.querySelector('.keyword');
  // const mainKeywordContainer = document.querySelector('.keyword ul');
  // const mainKeywordSliders = document.querySelectorAll('.keyword ul li');
  
  // STAFF PICK 영역 - 모바일에서 슬라이드
  const mainStaffPick = document.querySelector('.custom-main-staff-pick');
  const mainStaffPickContainer = document.querySelector('.custom-main-staff-pick ul');
  const mainStaffPickSliders = document.querySelectorAll('.custom-main-staff-pick ul li');
  
  // Swiper 초기화
  let mainHeroSwiper = null;
  // let mainBlogStoriesSwiper = null;
  // let mainBlogTrendSwiper = null;
  // let mainBlogPeopleSwiper = null;
  // let mainKeywordSwiper = null;
  let mainStaffPickSwiper = null;
  
  function mainInitSwiper() {
    // Hero
    mainHeroSwiper = new Swiper('.custom-col-hero', {
      // Swiper 설정 옵션들
      slidesPerView: 1,
      spaceBetween: 16,
      preloadImages: false,
      lazy:{
        loadPrevNext:true,
      },
      autoHeight: true,
      on:{
        // 이미지 autoheight 안될 때
        lazyImageReady: function() {
          var swiper = this;
          setTimeout(function() {
            swiper_issue.updateAutoHeight();
          }, 100);
        },
      },
      pagination: {
        el: '.custom-col-hero .swiper-pagination',
        type: 'bullets'
      }
    });
  
    // Editorial Stories
    // mainBlogStoriesSwiper = new Swiper('.editorial.stories', {
    //   // Swiper 설정 옵션들
    //   slidesPerView: 1.3,
    //   spaceBetween: 16,
    //   slidesOffsetBefore: 16,
    //   slidesOffsetAfter: 16, 
    // });
    
    // Editorial Trend
    // mainBlogTrendSwiper = new Swiper('.editorial.trend', {
    //   // Swiper 설정 옵션들
    //   slidesPerView: 1.3,
    //   spaceBetween: 16,
    //   slidesOffsetBefore: 16,
    //   slidesOffsetAfter: 16, 
    // });
    
    // Editorial People
    // mainBlogPeopleSwiper = new Swiper('.editorial.people', {
    //   // Swiper 설정 옵션들
    //   slidesPerView: 1.3,
    //   spaceBetween: 16,
    //   slidesOffsetBefore: 16,
    //   slidesOffsetAfter: 16, 
    // });
    
    // Keyword
    // mainKeywordSwiper = new Swiper('.keyword', {
    //   // Swiper 설정 옵션들
    //   slidesPerView: 1.5,
    //   spaceBetween: 0,
    //   pagination: {
    //     el: '.keyword .swiper-pagination',
    //     type: 'bullets'
    //   },
    //   breakpoints: {  
    //     1024: { // PC 1024px ~ (Destroy)
    //       slidesPerView: 1.5,
    //       spaceBetween: 0,
    //     },
    //     280: { // Mobile 280px ~ 1023px
    //       slidesPerView: 1.1,
    //       spaceBetween: 16,
    //     },
    //   },
    // });
    
    // Staff Pick
    mainStaffPickSwiper = new Swiper('.custom-main-staff-pick', {
      // Swiper 설정 옵션들
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.custom-main-staff-pick .swiper-pagination',
        type: 'bullets'
      }
    });
  }
  
  function mainDestroySwiper() {
    if (mainHeroSwiper !== null || mainStaffPickSwiper !== null) {
      mainHeroSwiper.destroy(true, true);
      mainHeroSwiper = null;
  
      // mainBlogStoriesSwiper.destroy(true, true);
      // mainBlogStoriesSwiper = null;
      
      // mainBlogTrendSwiper.destroy(true, true);
      // mainBlogTrendSwiper = null;
      
      // mainBlogPeopleSwiper.destroy(true, true);
      // mainBlogPeopleSwiper = null;
      
      // mainKeywordSwiper.destroy(true, true);
      // mainKeywordSwiper = null;
      
      mainStaffPickSwiper.destroy(true, true);
      mainStaffPickSwiper = null;
    }
  }
  
  // 창 크기에 따라 Swiper Init & Destroy
  function mainHandleSwiper() {
    if (window.innerWidth <= 1023) {
      mainHero.classList.add('swiper-container');
      mainHeroContainer.classList.add('swiper-wrapper');
      mainHeroSliders.forEach(slider => slider.classList.add('swiper-slide'));
      
      // mainBlogStories.classList.add('swiper-container');
      // mainBlogStoriesContainer.classList.add('swiper-wrapper');
      // mainBlogStoriesSliders.forEach(slider => slider.classList.add('swiper-slide'));
      
      // mainBlogTrend.classList.add('swiper-container');
      // mainBlogTrendContainer.classList.add('swiper-wrapper');
      // mainBlogTrendSliders.forEach(slider => slider.classList.add('swiper-slide'));
      
      // mainBlogPeople.classList.add('swiper-container');
      // mainBlogPeopleContainer.classList.add('swiper-wrapper');
      // mainBlogPeopleSliders.forEach(slider => slider.classList.add('swiper-slide'));
      
      // mainKeyword.classList.add('swiper-container');
      // mainKeywordContainer.classList.add('swiper-wrapper');
      // mainKeywordSliders.forEach(slider => slider.classList.add('swiper-slide'));
      
      mainStaffPick.classList.add('swiper-container');
      mainStaffPickContainer.classList.add('swiper-wrapper');
      mainStaffPickSliders.forEach(slider => slider.classList.add('swiper-slide'));
  
      if (!mainHeroSwiper || mainStaffPickSwiper) { // swiper가 초기화되지 않았을 때만 실행
        mainInitSwiper();
      }
    } else {
      mainHero.classList.remove('swiper-container');
      mainHeroContainer.classList.remove('swiper-wrapper');
      mainHeroSliders.forEach(slider => slider.classList.remove('swiper-slide'));
      
      // mainBlogStories.classList.remove('swiper-container');
      // mainBlogStoriesContainer.classList.remove('swiper-wrapper');
      // mainBlogStoriesSliders.forEach(slider => slider.classList.remove('swiper-slide'));
      
      // mainBlogTrend.classList.remove('swiper-container');
      // mainBlogTrendContainer.classList.remove('swiper-wrapper');
      // mainBlogTrendSliders.forEach(slider => slider.classList.remove('swiper-slide'));
      
      // mainBlogPeople.classList.remove('swiper-container');
      // mainBlogPeopleContainer.classList.remove('swiper-wrapper');
      // mainBlogPeopleSliders.forEach(slider => slider.classList.remove('swiper-slide'));
      
      // mainKeyword.classList.remove('swiper-container');
      // mainKeywordContainer.classList.remove('swiper-wrapper');
      // mainKeywordSliders.forEach(slider => slider.classList.remove('swiper-slide'));
      
      mainStaffPick.classList.remove('swiper-container');
      mainStaffPickContainer.classList.remove('swiper-wrapper');
      mainStaffPickSliders.forEach(slider => slider.classList.remove('swiper-slide'));
  
      if (mainHeroSwiper || mainStaffPickSwiper) { // swiper가 초기화되어 있을 때만 실행
        mainDestroySwiper();
      }
    }
  }
  
  // 창 크기 변경 감지
  
  window.addEventListener('resize', mainHandleSwiper);
  
  // 페이지 로드 시에도 초기화
  mainHandleSwiper();

});


// Blog Post는 아래와 같이 수정
// Swiper 초기화 함수 (선택자가 있을 경우에만 초기화)
/**
 * 
 * @param {string} selector init할 슬라이드
 * @param {string} paginationSelector 각 슬라이드 pagination
 * @returns 
 */
function initSwiper(selector, paginationSelector) {
  const element = document.querySelector(selector);
  if (element) {
    return new Swiper(selector, {
      slidesPerView: 1.3,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16, 
      pagination: {
        el: paginationSelector,
        type: 'bullets',
      },
    });
  } else {
    // console
    console.warn(`Swiper element not found for selector: ${selector}`);
    return null;
  }
}

// Swiper init & destroy 관련
function destroySwiper(swiperInstance) {
  if (swiperInstance !== null) {
    swiperInstance.destroy(true, true);
  }
}

// 슬라이드 관련 클래스를 추가/제거
/**
 * 
 * @param {string} element swiper-container
 * @param {string} container swiper-wrapper
 * @param {string} sliders swiper-slide
 * @param {boolean} add True & False
 */
function toggleSwiperClasses(element, container, sliders, add) {
  if (element && container && sliders.length > 0) {
    if (add) {
      element.classList.add('swiper-container');
      container.classList.add('swiper-wrapper');
      sliders.forEach(slider => slider.classList.add('swiper-slide'));
    } else {
      element.classList.remove('swiper-container');
      container.classList.remove('swiper-wrapper');
      sliders.forEach(slider => slider.classList.remove('swiper-slide'));
    }
  }
}

// Swiper 관련 변수
let blogStoriesSwiper = null;
let blogTrendSwiper = null;
let blogBrandlabSwiper = null;
let blogPeopleSwiper = null;

// 창 크기에 따라 Swiper Init & Destroy
function blogHandleSwiper() {
  const isMobile = window.innerWidth <= 1023;

  // 각 카테고리에 대해 Swiper 설정 및 초기화
  const categories = [
    {
      selector: '.editorial.stories-new',
      paginationSelector: '.editorial.stories-new .swiper-pagination',
      swiperInstance: blogStoriesSwiper,
      setSwiper: swiper => (blogStoriesSwiper = swiper),
    },
    {
      selector: '.editorial.trend-new',
      paginationSelector: '.editorial.trend-new .swiper-pagination',
      swiperInstance: blogTrendSwiper,
      setSwiper: swiper => (blogTrendSwiper = swiper),
    },
    {
      selector: '.editorial.people-new',
      paginationSelector: '.editorial.people-new .swiper-pagination',
      swiperInstance: blogPeopleSwiper,
      setSwiper: swiper => (blogPeopleSwiper = swiper),
    },
  ];

  categories.forEach(({ selector, paginationSelector, swiperInstance, setSwiper }) => {
    const element = document.querySelector(selector);
    const container = element ? element.querySelector('ol') : null;
    const sliders = container ? container.querySelectorAll('li') : null;

    if (element && container && sliders.length > 0) {
      if (isMobile) {
        // Mobile에서 Init
        toggleSwiperClasses(element, container, sliders, true);
        if (!swiperInstance) {
          const swiper = initSwiper(selector, paginationSelector);
          setSwiper(swiper);
        }
      } else {
        // Mobile에서 Destroy
        toggleSwiperClasses(element, container, sliders, false);
        destroySwiper(swiperInstance);
        setSwiper(null);
      }
    } else {
      // Console
      console.warn(`Required elements not found for selector: ${selector}`);
    }
  });
}

// 창 크기 변경 감지
window.addEventListener('resize', blogHandleSwiper);

// 페이지 로드 시에도 초기화
blogHandleSwiper();
